import React from 'react';

const Stat = ({ value, label }) => (
  <div className="analytics-stat">
    <span className="stat-value">{value}</span>
    <span className="stat-label">{label}</span>
  </div>
);

const EmailAnalyticsBar = ({ analytics }) => {
  if (!analytics) return null;
  return (
    <div className="email-analytics-bar">
      <Stat value={analytics.total_campaigns} label="Campaigns" />
      <Stat value={analytics.total_emails_sent} label="Emails Sent" />
      <Stat value={analytics.total_opens} label="Opens" />
      <Stat value={`${analytics.average_open_rate}%`} label="Open Rate" />
      <Stat value={analytics.total_clicks} label="Clicks" />
      <Stat value={`${analytics.average_click_rate}%`} label="Click Rate" />
    </div>
  );
};

export default EmailAnalyticsBar;
